import styled from "styled-components";
import { breakpoints } from "../../../constants/media";

const Container = styled.div`
  width: 100%;
  max-width: 1266px;
  margin: 170px 0px 0px 0px;
  background-color: var(--white);
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: row;

  // Title
  h2 {
    width: 100%;
    text-align: center;
    color: var(--black);
    font-family: Raleway;
    font-style: normal;
    font-weight: bold;
    font-size: 2.25em;
    letter-spacing: -0.015em;
    margin: 0px 0px 0px 0px;
  }

  // Beneficios Container
  .beneficiosContainer {
    width: 100%;
    margin: 80px 0px 0px 0px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    flex-direction: row;
  }

  // Cards
  .beneficiosContainer div {
    width: 33.3%;
    max-width: 350px;
    border-radius: 12px;
  }

  // Beneficios
  .beneficiosContainer div div {
    width: 100%;
    min-height: 240px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    align-content: flex-start;
    border: 2px solid var(--orange);
    border-radius: 12px;
  }

  // Beneficio Title
  .beneficiosContainer div div h3 {
    max-width: 300px;
    width: 100%;
    font-family: Raleway;
    font-style: normal;
    font-weight: bold;
    font-size: 1.3em;
    line-height: 36px;
    text-align: center;
    margin: 30px 0px 0px 0px;
    padding: 0px 0px 0px 0px;
  }

  // Beneficio Text
  .beneficiosContainer div div p {
    max-width: 290px;
    font-family: Raleway;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 28px;
    text-align: center;
    color: var(--black);
    margin: 13px 0px 0px 0px;
  }

  // Beneficios Contacto
  #textComunicate {
    width: 100%;
    font-family: Raleway;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 28px;
    text-align: center;
    color: var(--black);
    padding: 40px 0px 40px 0px;
  }

  // Beneficio Asistencia Text
  #parrafoAsistencia {
    margin: 47px 0px 0px 0px !important;
  }

  // Cotizar Button
  a {
    font-family: Raleway;
    font-style: normal;
    font-weight: bold;
    font-size: 1.1em;
    color: var(--white);
    padding: 12px 40px 12px 40px;
    border-radius: 6px;
    background-color: var(--orange);
    border: 0px solid;
    transition: 0.2s;
    cursor: pointer;
    text-align: center;
    margin-top: 60px;
  }

  // Cotizar Button Hover
  a:hover {
    background-color: var(--lightorange);
  }

  // 1710px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1710}) {
    // Title
    h2 {
      font-size: 2em;
    }

    // Beneficio Title
    .beneficiosContainer div div h3 {
      font-size: 1.3em;
    }

    // Beneficio Text
    .beneficiosContainer div div p {
      font-size: 0.96em;
    }

    // Beneficios Contacto
    #textComunicate {
      font-size: 1em;
    }

    // Cotizar Button
    a {
      font-size: 1.1em;
    }
  }

  // 1600px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1600}) {
    max-width: 1100px;

    // Beneficios
    .beneficiosContainer div {
      width: 33.3%;
      max-width: 330px;
    }

    // Beneficio Title
    .beneficiosContainer div div h3 {
      max-width: 280px;
      line-height: 32px;
    }

    // Beneficio Text
    .beneficiosContainer div div p {
      max-width: 280px;
    }

    #parrafoAsistencia {
      margin: 45px 0px 0px 0px !important;
    }
  }

  // 1440px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1440}) {
    // Title
    h2 {
      font-size: 1.9em;
    }

    // Beneficio Title
    .beneficiosContainer div div h3 {
      font-size: 1.1em;
    }

    // Beneficio Text
    .beneficiosContainer div div p {
      font-size: 0.938em;
    }

    // Beneficios Contacto
    #textComunicate {
      font-size: 0.938em;
    }

    // Cotizar Button
    a {
      font-size: 1em;
    }
  }

  // 1366px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1366}) {
    max-width: 1000px;
    margin: 130px 0px 0px 0px;

    // Beneficios
    .beneficiosContainer div {
      width: 33.3%;
      max-width: 310px;
    }

    // Beneficios Contacto
    #textComunicate {
      width: 60%;
      text-align: center;
      margin: 0 auto;
    }
  }

  // 1200px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1200}) {
    max-width: 850px;
    margin: 110px 0px 0px 0px;

    // Beneficios
    .beneficiosContainer div {
      width: 33.3%;
      max-width: 260px;
    }

    // Beneficio Title
    .beneficiosContainer div div h3 {
      max-width: 240px;
      line-height: 30px;
    }

    // Beneficio Text
    .beneficiosContainer div div p {
      max-width: 240px;
    }
  }

  // 1024px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet1024}) {
    max-width: 700px;

    // Beneficios
    .beneficiosContainer div {
      width: 100%;
      max-width: 100%;
    }

    // Beneficios
    .beneficiosContainer div div {
      min-height: 150px;
      align-items: center;
      align-content: center;
      margin: 30px 0px 0px 0px;
    }

    // Beneficio Title
    .beneficiosContainer div div h3 {
      width: 90%;
      max-width: 90%;
      line-height: 30px;
      margin: 0px 0px 0px 0px;
    }

    // Beneficio Text
    .beneficiosContainer div div p {
      width: 90%;
      max-width: 90%;
      margin: 10px 0px 0px 0px;
    }

    #parrafoAsistencia {
      margin: 10px 0px 0px 0px !important;
    }
  }

  // 850px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet850}) {
    max-width: 600px;
  }

  // 768px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet768}) {
    max-width: 540px;
  }

  // 670px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet670}) {
    max-width: 480px;
    margin: 80px 0px 0px 0px;

    // Title
    h2 {
      text-align: left;
    }

    // Beneficios Container
    .beneficiosContainer {
      margin: 0px 0px 0px 0px;
    }

    // Beneficios
    .beneficiosContainer div div {
      margin: 40px 0px 0px 0px;
      align-items: flex-start;
      align-content: flex-start;
    }

    // Beneficio Title
    .beneficiosContainer div div h3 {
      width: 85%;
      max-width: 85%;
      margin: 15px 0px 0px 0px;
    }

    // Beneficio Text
    .beneficiosContainer div div p {
      width: 85%;
      max-width: 85%;
      margin: 10px 0px 0px 0px;
    }

    #textComunicate {
      width: 90%;
    }
  }

  // 651px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile651}) {
    max-width: 400px;

    // Beneficio Title
    .beneficiosContainer div div h3 {
      width: 95%;
      max-width: 95%;
    }
  }

  // 450px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile450}) {
    max-width: 88%;

    // Beneficio Text
    .beneficiosContainer div div p {
      padding: 0px 0px 10px 0px;
    }
  }
`;

export default Container;
